import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import { Flex, Box } from "grid-styled";

import {
  CompanyImage,
  CompanyReferences,
  CompanyTitle,
  Img,
  ImgScaled,
  NoWrap,
  P,
  Page,
  TextBlock,
  TitleThumb,
  Ul
} from "../styled-components";

import logoWeiss from "../img/0240/logo/logoWeiss.png";
import bilder from "../bilder/start";

import events from "../bilder/events";
import tagungen from "../bilder/tagungen";
import incentives from "../bilder/incentives";
import messen from "../bilder/messen";
import konzerte from "../bilder/konzerte";
import architektur from "../bilder/architektur";
import impressionen from "../bilder/impressionen";
import koeln from "../bilder/koeln";

class Start extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Fotografie Anders</title>
        </Helmet>
        <Flex flexDirection="column" alignItems="center">
          <ImgScaled
            data-sizes="100vw"
            srcSet={bilder[1].min}
            src={bilder[1].max}
            data-srcset={bilder[1].srcset}
            className="lazyload blur-up"
            alt="Bild 01"
            width="100%"
          />
        </Flex>
        <Page>
          <Flex flexDirection="column" alignItems="center">
            <CompanyImage src={logoWeiss} alt="Logo weiß" width="240" />
            <CompanyTitle>
              STEPHAN ANDERS
              <br />
              FOTOGRAFIE
            </CompanyTitle>
          </Flex>
          <Flex flexWrap="wrap">
            <Box width={[1, 1 / 2]} pr={[0, 4]}>
              <TextBlock>
                <P>
                  Sie planen eine Veranstaltung und möchten diese professionell
                  fotografieren lassen?
                </P>

                <P>
                  Mein Leistungsspektrum reicht von Business Events über
                  Tagungen zu Incentives. Als Fotograf agiere ich dabei
                  unauffällig, respektvoll und unaufdringlich — aber bin doch
                  immer mittendrin im Geschehen. Gerne begleite ich Ihre
                  Veranstaltungen in Köln und Umgebung, in ganz Deutschland und
                  auch international.
                </P>

                <P>
                  Ebenfalls erstelle ich für Ihr Unternehmen Profile. Dazu
                  gehören Fotos Ihrer Vorstände oder Geschäftsführer, Ihres
                  Managements oder Ihrer Mitarbeiter sowie die Fotografie von
                  Ihren Unternehmensgebäuden und Betriebsstätten. Natürlich
                  dokumentiere ich auch Ihre Messeauftritte.
                </P>
              </TextBlock>
            </Box>
            <Box width={[1, 1 / 2]} pl={[0, 4]}>
              <TextBlock>
                <P>
                  Ihre Wünsche und Vorstellungen stehen bei mir im Mittelpunkt.
                  Ich berate Sie gerne in einem unverbindlichen Vorgespräch —
                  individuell und unkompliziert, damit bei Ihnen keine Fragen
                  offen bleiben. Wie ich Sie am besten unterstützen kann,
                  besprechen wir am besten gemeinsam. Bitte schauen Sie auch auf
                  meine Referenzen.
                </P>
                <P>
                  Ich freue mich auf Ihre Nachricht. Am einfachsten ist es, Sie
                  schreiben mir eine <NoWrap>E-Mail</NoWrap>:
                </P>
                <P>info@fotografie-anders.com</P>
              </TextBlock>
            </Box>
          </Flex>
          <CompanyReferences>
            <hr />
            <Box width={[1]}>
              <P>REFERENZEN (Auswahl):</P>
            </Box>
            <Flex flexWrap="wrap">
              <Box width={[1, 1 / 2]} pr={[0, 4]}>
                <Ul>
                  <li>Apeiron AG</li>
                  <li>Brainstorm GmbH</li>
                  <li>Brandaudio</li>
                  <li>Busch-Jäger Elektro GmbH</li>
                  <li>Klinik am Ring, Mund- Kiefer-, Gesichts-Chirurgie</li>
                  <li>Daimler AG</li>
                  <li>Deutsche Aktuar Vereinigung e.V.</li>
                  <li>FCA Germany AG – Fiat Professional</li>
                  <li>Fiducia & GAD IT AG</li>
                  <li>Henkel AG & Co. KGaA – Laundry & Home Care</li>
                </Ul>
              </Box>
              <Box width={[1, 1 / 2]} pl={[0, 4]}>
                <Ul>
                  <li>Henkel Laundry & Home Care Benelux</li>
                  <li>
                    Institut der Versicherungsmathematischen Sachverständigen
                    für Altersversorgung e.V.
                  </li>
                  <li>L'Osteria &mdash; Pizza E Pasta</li>
                  <li>Linkit Consulting GmbH</li>
                  <li>Malteser Hilfsdienst e.V.</li>
                  <li>M.D.C. International GmbH</li>
                  <li>Montag & Montag Unternehmensberater Partnerschaft</li>
                  <li>Qiagen GmbH</li>
                  <li>Schlüsselerlebnisse GmbH</li>
                </Ul>
              </Box>
            </Flex>
            <hr />
          </CompanyReferences>

          <Flex flexWrap="wrap">
            {this.renderThumbs("Events", "events", events)}
            {this.renderThumbs("Tagungen", "tagungen", tagungen)}
            {this.renderThumbs("Incentives", "incentives", incentives)}
            {this.renderThumbs("Messen", "messen", messen)}
            {this.renderThumbs("Konzerte", "konzerte", konzerte)}
            {this.renderThumbs("Architektur", "architektur", architektur)}
            {this.renderThumbs("Impressionen", "impressionen", impressionen)}
            {this.renderThumbs("Köln", "koeln", koeln)}
          </Flex>
        </Page>
      </div>
    );
  }

  renderThumbs = (category, path, thumbs, number = 1) => {
    return (
      <Box width={[1, 1 / 2, 1 / 4]} px={[0, 1]}>
        <Link to={"/" + path}>
          <TitleThumb>{category} ...</TitleThumb>
          <Img
            data-sizes="420px"
            src={thumbs[number]["0420"]}
            className="lazyload blur-up"
            alt={"Thumb " + number}
          />
        </Link>
      </Box>
    );
  };
}

export default Start;



// WEBPACK FOOTER //
// ./src/pages/Start.js